// field is required
required = value => value.toString().length > 0 ? false : 'This field is required.';

// field has minimum length
minLength = len => value => value.length > len ? false : `The minimum length is ${len}`;

// field has a max length
maxLength = len => value => value.length < len ? false : `The minimum length is ${len}`;

// field has to be an email or empty
const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
email = value => emailRegex.test(value) || value === '' ? false : 'Please enter a valid email.';

// field has to be a number or empty
const numberRegex = /^[0-9]+(\.[0-9]+)?$/
number = value => !value || numberRegex.test(value.toString()) || value.toString() === '' ? false : 'Please enter a valid number'

module.exports = {
  required,
  minLength,
  maxLength,
  email,
  number,
};
